import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';
import { idType, idNumber, gender, date } from 'Utils/validations';

const PersonalInfoFormSchema = Yup.object().shape(
  reverseShape({
    displayName: Yup.string().optional(),
    idType: Yup.mixed().required().concat(idType),
    idNumber: Yup.string().required().concat(idNumber),
    gender: Yup.string().optional(),
    dob: Yup.string().optional(),
    mobilePhone: Yup.string().required(),
  })
)

export default PersonalInfoFormSchema;
